import { useState } from 'react';
import { Alert, Paper, SegmentedControl, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons';
import { PlaygroundItemsPanel } from './common/playground-items-panel';
import { PlaygroundInvokePanel } from './common/playground-invoke-panel';

type PlaygroundView = 'items' | 'invoke';

interface IntegrationPlaygroundTabProps {
  accountId: string;
  integrationKey: string;
}

export function IntegrationPlaygroundTab({
  accountId,
  integrationKey,
}: IntegrationPlaygroundTabProps) {
  const [view, setView] = useState<PlaygroundView>('items');

  return (
    <Stack spacing="md">
      <Alert icon={<IconAlertTriangle size={16} />} color="orange" variant="light">
        These queries hit the customer&apos;s live integration and consume the same external API
        rate limits as production sync. Keep queries narrow.
      </Alert>

      <SegmentedControl
        value={view}
        onChange={(value) => setView(value as PlaygroundView)}
        data={[
          { label: 'Items', value: 'items' },
          { label: 'SDK console', value: 'invoke' },
        ]}
      />

      <Paper withBorder p="lg">
        {view === 'items' ? (
          <PlaygroundItemsPanel accountId={accountId} integrationKey={integrationKey} />
        ) : (
          <PlaygroundInvokePanel accountId={accountId} integrationKey={integrationKey} />
        )}
      </Paper>
    </Stack>
  );
}
